import React from 'react';
import { get } from 'lodash';
import cx from 'classnames';
import StringWidget from 'components/StringWidget';
import { numFormat } from 'utils/numFormat';
import styles from './PriceWidget.css';
import PlusPrice from 'components/PriceWidget/PlusPrice';
import Tags from 'components/Tags';
export var PriceWidgetDisplay;
(function (PriceWidgetDisplay) {
    PriceWidgetDisplay["sellingPrice"] = "selling-price";
    PriceWidgetDisplay["oldPrice"] = "old-price";
    PriceWidgetDisplay["discount"] = "discount";
    PriceWidgetDisplay["plusPrice"] = "plus-price";
    PriceWidgetDisplay["priceTags"] = "price-tags";
})(PriceWidgetDisplay || (PriceWidgetDisplay = {}));
export default function PriceWidget(props) {
    const { containerClassName, pricing, sellingPriceClass, oldPriceClass, discountClass, noPriceClass, plusPriceClass, showDiscount = true, digitalFreebiePriceCallout, display = [
        PriceWidgetDisplay.sellingPrice,
        PriceWidgetDisplay.oldPrice,
        PriceWidgetDisplay.discount,
        PriceWidgetDisplay.priceTags,
        PriceWidgetDisplay.plusPrice
    ], children } = props;
    if (!pricing || !pricing.prices || !pricing.prices.length) {
        return (<div className={cx(styles['price-widget'])}>
				<div className={cx(styles['no-price'], noPriceClass)}>
					<StringWidget strKey="priceNotAvailable"/>
				</div>
			</div>);
    }
    const oldPrice = pricing.prices[0];
    const sellingPrice = `₹${numFormat(Number(pricing.prices[pricing.prices.length - 1].value))}`;
    const isDiscountInAmount = pricing.showDiscountAsAmount;
    const discount = isDiscountInAmount && pricing.discountAmount && pricing.discountAmount > 0
        ? `${pricing.discountAmount}`
        : (pricing.totalDiscount && pricing.totalDiscount > 0 && `${pricing.totalDiscount}`) || '';
    const mrp = numFormat(Number(oldPrice.value));
    const discountString = (<StringWidget attributes={{ discountAmount: discount }} strKey={isDiscountInAmount ? 'discountTextInRupee' : 'discountText'}/>);
    const priceTags = get(pricing, 'priceTags');
    return (<React.Fragment>
			<div className={cx(styles['price-widget'], containerClassName)}>
				{display.indexOf(PriceWidgetDisplay.sellingPrice) > -1 ? (<div className={cx(styles['selling-price'], sellingPriceClass)}>{sellingPrice}</div>) : null}
				{display.indexOf(PriceWidgetDisplay.oldPrice) > -1 && oldPrice.strikeOff ? (<div className={cx(styles['old-price'], oldPriceClass)}>₹{mrp}</div>) : null}
				{display.indexOf(PriceWidgetDisplay.discount) > -1 &&
        showDiscount &&
        discount &&
        !digitalFreebiePriceCallout ? (<div className={cx(styles['discount'], discountClass)}>{discountString}</div>) : null}
				{digitalFreebiePriceCallout ? (<div className={cx(styles['discount'], discountClass)}>{digitalFreebiePriceCallout}</div>) : null}
				{children}
			</div>
			{display.indexOf(PriceWidgetDisplay.plusPrice) > -1 && (<PlusPrice plusPriceInfo={pricing.plusPriceInfo} plusPriceClass={plusPriceClass}/>)}

			{display.indexOf(PriceWidgetDisplay.priceTags) > -1 && <Tags tags={priceTags}/>}
		</React.Fragment>);
}
